import {
  AutoComplete,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Space,
} from 'antd';
import EmployeeSelectorComponent from '../../shared/employee-selector/employee-selector.component';
import {
  useListEmployees,
  useSalaryAdjustmentTypes,
} from '../../utils/api-hooks/employee.hook';
import { map } from 'lodash';
import { FormInstance } from 'antd/lib';
import { useImperativeHandle } from 'react';
import FormItem from 'antd/es/form/FormItem';
import { FunctionInfoComponent } from '../../shared/function-info.component';
import { useForm } from 'antd/es/form/Form';
import { CreateEmployeeSalaryAdjustmentDto } from '../../utils/api-client';
import { EMPLOYEE_STATE, EMPLOYEE_STATE_LABEL } from '../../constants/employee';
import { Dayjs } from 'dayjs';

type EmployeeSalaryAdjustmentFormProps = {
  formRef: React.RefObject<FormInstance>;
  initialValues?: Omit<CreateEmployeeSalaryAdjustmentDto, 'time'> & {
    adjustmentType: 'ADDITION' | 'DEDUCTION';
    time: Dayjs;
  };
};

export default function EmployeeSalaryAdjustmentFormComponent(
  props: EmployeeSalaryAdjustmentFormProps
) {
  const {
    data: { data: employees } = {},
    isLoading,
    isFetching,
  } = useListEmployees();
  const [form] = useForm<
    CreateEmployeeSalaryAdjustmentDto & {
      adjustmentType: 'ADDITION' | 'DEDUCTION';
      time: Dayjs;
    }
  >();
  const { data: { data: salaryAdjustmentTypes } = {} } =
    useSalaryAdjustmentTypes();

  useImperativeHandle(props.formRef, () => form, [form]);

  return (
    <Form
      form={form}
      autoComplete="off"
      preserve={false}
      initialValues={props.initialValues}
    >
      <EmployeeSelectorComponent
        isRequired
        disabled={!!props.initialValues?.employeeId}
        loading={isLoading || isFetching}
        options={map(employees, (employee) => ({
          value: employee.id,
          label: `${employee.idNumber ? `${employee.idNumber} - ` : ''}${employee.name}${employee.state === EMPLOYEE_STATE.SUSPENDED ? `( ${EMPLOYEE_STATE_LABEL.SUSPENDED})` : ''}`,
        }))}
      />
      <FormItem
        label={
          <Space>
            <span>加減項</span>
            <FunctionInfoComponent title="此欄位用來決定是加項還是減項，例如：要給員工加班費，選加項；遲到罰款，選減項" />
          </Space>
        }
        name="adjustmentType"
        rules={[{ required: true, message: '請選擇加減項' }]}
      >
        <Radio.Group
          options={[
            { label: '加項', value: 'ADDITION' },
            { label: '減項', value: 'DEDUCTION' },
          ]}
        />
      </FormItem>
      <FormItem
        label="時間"
        name="time"
        rules={[{ required: true, message: '請選擇時間' }]}
      >
        <DatePicker />
      </FormItem>
      <FormItem
        label="名目"
        name="type"
        rules={[{ required: true, message: '請填寫名目' }]}
      >
        <AutoComplete
          options={map(salaryAdjustmentTypes, (type) => ({
            value: type,
          }))}
        />
      </FormItem>
      <FormItem
        label="金額"
        name="amount"
        rules={[
          { required: true, message: '請輸入調整金額' },
          { type: 'number', message: '請輸入正確的金額' },
        ]}
      >
        <InputNumber />
      </FormItem>
      <FormItem label="備註" name="note" rules={[{ required: false }]}>
        <Input.TextArea />
      </FormItem>
    </Form>
  );
}
